import r from "../managers/braze-instance.js";
import HtmlMessage from "./models/html-message.js";
import se from "./in-app-message-manager-factory.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageHtmlClick(e, t, s) {
  if (!r.rr()) return !1;
  if (!(e instanceof HtmlMessage))
    return (
      N.error(
        "inAppMessage argument to logInAppMessageHtmlClick must be an HtmlMessage object.",
      ),
      !1
    );
  let o = d.Fi;
  null != t && (o = d.Oi);
  const m = se.ea().ut(e, o, t, s);
  if (m.tt)
    for (let r = 0; r < m.$e.length; r++)
      rt.m().Ce(ot.Qr, [e.triggerId, t], m.$e[r]);
  return m.tt;
}
